import Button, { ButtonProps } from '@/shared/components/buttons/Button'
import * as React from 'react'
import { ReactNode } from 'react'
import Spinner from '@/shared/components/Spinner'
import clsx from 'clsx'
import { TooltipWithBody } from '@/shared/components/common/Tooltip'

type Props = {
  icon: ReactNode
  className?: string
  tooltip?: string
} & Omit<ButtonProps, 'children'>

export default function IconSquareButton({
  icon,
  tooltip,
  loading,
  className,
  ...props
}: Props) {
  const button = (
    <Button
      loading={loading}
      {...props}
      className={clsx(
        'flex h-11 w-11 items-center justify-center text-center',
        className,
      )}
    >
      <div>
        {loading ? (
          <Spinner size={5} />
        ) : (
          <div className={clsx(props.disabled && 'opacity-50')}>{icon}</div>
        )}
      </div>
    </Button>
  )

  if (tooltip) {
    return <TooltipWithBody body={button} content={tooltip} />
  }

  return button
}
